import { alpha, styled } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Fonts from "../../Config/Fonts";
import Colors from "../../theme/Colors";

export const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: "auto",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

export const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

// Styled components
export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${TableCell.head}`]: {
    backgroundColor: "#F0F5FF", // Set your desired background color here
    color: theme.palette.common.black,
    fontSize: 16, // Apply fontSize if needed
    fontWeight: "700", // Apply fontWeight if needed
    fontFamily: Fonts.NunitoSans, // Apply fontFamily if needed
  },
  [`&.${TableCell.body}`]: {
    backgroundColor: "#F0F5FF",
    fontSize: 14,
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#F0F5FF",
  },
  "&:last-child td, &:last-child th": {
    border: 0,
    backgroundColor: "#F0F5FF",
  },
}));

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));

export const TableWrapper = styled("div")({
  overflow: "auto",
  maxHeight: "700px", // Adjust the height as neede
});

// Inline styles
export const exportBtn = {
  marginTop: "8px",
  marginLeft: "10px",
  height: "40px",
  fontSize: 14,
  fontWeight: "400",
  fontFamily: Fonts.NunitoSans,
  color: Colors.darkGray,
};

export const addBtn = {
  marginTop: "8px",
  marginLeft: "10px",
  height: "40px",
  fontSize: 14,
  fontWeight: "400",
  fontFamily: Fonts.NunitoSans,
  color: Colors.white,
};

export const tableLabelStyle = {
  fontSize: 12,
  fontWeight: "500",
  fontFamily: Fonts.Poppins,
  color: Colors.breadCrumbsColor,
  position: "sticky",
  top: 0,
  textAlign: "center",
  width: "45%",
  backgroundColor: 'red',
  border: "1px solid #E6E6E6",
};

export const tableInputStyle = {
  fontSize: 13,
  fontWeight: "600",
  fontFamily: Fonts.NunitoSans,
  color: Colors.darkGray,
  borderRight: "1px solid #ccc",
};

export const tableHeaderStyle = {
  fontSize: 12,
  fontWeight: "500",
  fontFamily: Fonts.Poppins,
  color: Colors.black,
};
